import { memo, useEffect } from "react";
import { type To, useNavigate, useParams } from "react-router-dom";

type RedirectProps = {
   to: To;
};

function Redirect({ to }: RedirectProps) {
   const navigate = useNavigate();
   const params = useParams();

   useEffect(() => {
      if (Object.keys(params).length > 0) {
         let readyTo = to.toString();

         Object.entries(params).forEach(([key, value]) => {
            if (value === undefined) return;

            readyTo = readyTo.replace(":" + key, value);
         });

         navigate(readyTo);
      } else navigate(to);
   }, [params, to]);

   return <></>;
}

export default memo(Redirect);
